import { PageHeader } from '@/components/ui'

/**
 * An honest placeholder for a screen that is intentionally not built yet.
 * Delete the component when the last one goes.
 */
export function NotBuiltYet({
  title,
  body,
}: {
  title: string
  body: string
}) {
  return (
    <>
      <PageHeader title={title} />
      <div className="rounded-md border border-dashed border-line bg-surface px-6 py-10">
        <p className="max-w-xl text-sm text-inksoft">{body}</p>
        <p className="ref mt-4">Not built yet</p>
      </div>
    </>
  )
}
